import polyglotI18nProvider from 'ra-i18n-polyglot'
import * as domainMessages from 'react-admin-import-csv/lib/i18n'
import { i18nDutch, i18nEnglish } from '../i18n'
import authProvider from './auth'
import { getUrl, xxllncDataProvider } from './data'

const messages = {
  en: { ...i18nEnglish, ...domainMessages.en },
  nl: { ...i18nDutch, ...domainMessages.nl },
}

const i18nProvider = polyglotI18nProvider(
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return
  (locale: string) => (messages[`${locale}`] ? messages[`${locale}`] : messages.en),
  'nl'
)

const providers = {
  auth: authProvider,
  data: xxllncDataProvider,
  i18n: i18nProvider,
  url: getUrl(),
}

export default providers
